import React from 'react';
import CustomTabPanel from 'components/Shared/CustomTabPanel';
import CustomTabs from 'components/Shared/CustomTabs';
import RowsSkeleton from 'components/Shared/Skeleton/RowsSkeleton';
import { useSearchParams } from 'react-router-dom';
import NoteTab from '../../Note/Notetab';
import { useGetNotesBySourceQuery } from 'store/services/noteApi';
import { useWarehousingDetailContext } from "contexts/WarehousingDetailContext";
import { useGetDocumentsBySourceQuery } from "store/services/documentApi";
import DocumentsTab from "../../Document/DocumentTab";
import WarehousingShipmentList from "./WarehousingShipmentList";

const WarehousingDetailTab = () => {

  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get('tab') || 'note';
  
 const { warehousingDetail } = useWarehousingDetailContext();
 
  // Fetch notes to get the count for the badge
  const { data: notes } = useGetNotesBySourceQuery(
    {
      source: 'Warehousing',
      sourceRef: warehousingDetail?._id,
    },
    { skip: !warehousingDetail?._id } 
  );

   // Fetch documents to get the count for the badge
      const { data: documents } = useGetDocumentsBySourceQuery(
          { source: 'Warehousing', sourceRef: warehousingDetail?._id, }, { skip: !warehousingDetail?._id }
      );

  const tabs = [
    {
      label: 'Note',
      value: 'note',
      badgeCount: notes?.length || 0, 
    },
    { label: "Document", value: "document", badgeCount: documents?.totalItems },

    { label: "Shipment", value: "shipment", badgeCount: warehousingDetail?.shipmentId?.length },
  ];

  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />

      {warehousingDetail ? (
        <>
        <CustomTabPanel activeTab={activeTab} value="note">
          <NoteTab source="Warehousing" sourceRef={warehousingDetail._id} />
        </CustomTabPanel>

         <CustomTabPanel activeTab={activeTab} value="document">
         <DocumentsTab source="Warehousing" sourceRef={warehousingDetail._id} />
     </CustomTabPanel>

     <CustomTabPanel activeTab={activeTab} value="shipment">
        <WarehousingShipmentList/>
     </CustomTabPanel>
 </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default WarehousingDetailTab;